import { WifiOff, CloudOff } from 'lucide-react';
import { useOnlineStatus } from '@/hooks/useOnlineStatus';
import { useServerUnreachable } from '@/hooks/useServerUnreachable';
import { studentI18n } from '@/i18n/studentI18n';
import styles from './OfflineBanner.module.scss';

/**
 * Franja global con dos causas, en orden de prioridad:
 *  1. El dispositivo no tiene conexión (`useOnlineStatus`).
 *  2. Hay internet pero el servidor de la API no responde
 *     (`useServerUnreachable`: proveedor caído, DNS, edge…). Se resuelve solo
 *     — un sondeo a /health oculta la franja cuando el servidor vuelve.
 * Se monta en `App`, fuera del `I18nextProvider`, por eso usa la instancia
 * `studentI18n` directamente.
 */
export function OfflineBanner() {
  const isOnline = useOnlineStatus();
  const serverUnreachable = useServerUnreachable();

  if (isOnline && !serverUnreachable) return null;

  const deviceOffline = !isOnline;

  return (
    <div className={styles.offlineBanner} role="status" aria-live="polite">
      {deviceOffline ? <WifiOff size={16} aria-hidden /> : <CloudOff size={16} aria-hidden />}
      <span>
        {studentI18n.t(deviceOffline ? 'errors.offlineBanner' : 'errors.serverUnreachableBanner')}
      </span>
    </div>
  );
}

export default OfflineBanner;
